import React, { Component } from 'react';
import './App.css';
//file drag and drop functionality
import FileDrop from "react-file-drop";
import './file-drop.css';

import Thumbnail from './components/Thumbnail';
import Toggle from './components/Toggle';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      "imgSrc":"",
      "title":"",
      "warnings":[],
      "showFullSize":false,
      isDarkMode: false,
    };
    this.onImageUpload = this.onImageUpload.bind(this);
    this.onImageDropped = this.onImageDropped.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
  }
  loadFiles(files){
    if (files && files[0]) {
        var file = files[0];

        //File Validation: file type
        const extension = file.name.match(/\.[0-9a-z]+$/i);
        const fileTypes = ['.gif', '.jpg', '.jpeg', '.png', '.bmp'];
        if(fileTypes.indexOf(extension.toString().toLowerCase()) === -1){
          const warningString = "Warning: Unrecognized file type. Use .GIF .JPG .PNG or .BMP";
          this.addWarning(warningString);
        }
        //end file type validation

        var reader = new FileReader();
        reader.addEventListener("load", (e)=> {
          e.stopPropagation();
          this.setState({imgSrc: reader.result});
          //File Validation: file size
          var head = 'data:image/png;base64,';
          var imgFileSize = Math.round((reader.result.length - head.length)*3/4) ;
          if((imgFileSize/1048576)>=2){ //converts bytes to Mb
            const warningString = "Warning: Large file size. Youtube limits file sizes to 2Mb.";
            this.addWarning(warningString);
          }
          //end file size validation
        }, false);
        if (file) {
          reader.readAsDataURL(file);
        }
    }
  }
  toggleMode() {
    this.setState({
      isDarkMode: !this.state.isDarkMode
    });
  }
  onImageUpload(event){
    event.stopPropagation();
    this.loadFiles(event.target.files);
  }
  onImageDropped(files, event){
    console.log("dropped");
    event.stopPropagation();
    this.loadFiles(files);
  }
  onTitleChange(event){
    this.setState({title: event.target.value});
  }
  imageLoadValidation = (event)=>{
    //File Validation: file aspect ratio
    if(event.target.width<640){
      this.addWarning(`Image width is too small (${event.target.width}px). Minimum 640px required.`);
    }
    //1280x720
    if(event.target.width < 1280 || event.target.height < 720){
      this.addWarning(`Recommended minimum image size is 1280x720. Current size: ${event.target.width}x${event.target.height}`);
    }

    //16:9
    if((event.target.width/16)*9 !== event.target.height){
      this.addWarning(`Recommended image aspect ratio is 16:9.`);
    }
    //end file aspect ratio validation
  }
  addWarning = (message)=>{
    if(!this.state.warnings.includes(message)){
      this.state.warnings.push(message)
      this.setState({"warnings":this.state.warnings});
    }

  }
  removeWarning = (warningkey)=>{
    this.setState({"warnings":[]});
  }
  handleScaledImageClick = ()=>{
    this.setState({"showFullSize":true});
  }
  handleFullImageClick = ()=>{
    this.setState({"showFullSize":false});
  }
  render() {
    let thumbs = undefined;
    let header = undefined;
    let footer = undefined;
    const { isDarkMode } = this.state;
    if (this.state.imgSrc === ""){
      //if image loaded, show full screen header
      header = (<FullPageHeader state={this.state}
                            onImageUpload={this.onImageUpload}
                          onImageDropped={this.onImageDropped}
                        onTitleChange={this.onTitleChange}/>);
    } else {
      //If no image, show partial header
      header = (<PartialHeader state={this.state}
                              onImageUpload={this.onImageUpload}
                            onImageDropped={this.onImageDropped}
                            onTitleChange={this.onTitleChange}/>)
      thumbs = (<GeneratedThumbnails state={this.state} toggleMode={this.toggleMode}></GeneratedThumbnails>);
      footer = (<Footer/>);
    }

    return (
      <div className="min-height-full" data-theme={isDarkMode ? 'dark' : 'light'}>
        <div className="App container-fluid min-height-full">
          <WarningBox warnings={this.state.warnings} removeWarning={this.removeWarning}/>
          {header}

          {thumbs}

          <img className="hidden-validation-image" src={this.state.imgSrc} onLoad={this.imageLoadValidation} alt=""/>

        </div>
        {footer}
      </div>
    );
  }
}
export default App;


class PartialHeader extends Component{
  render(){
    return (
      <div className="row App-header">
        <section className=" col">
          <div className="row">
            <header className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 text-center">
              <div className="image-input-wrapper embed-responsive embed-responsive-16by9">
                <ImageInput imageUploadHandler={this.props.onImageUpload}>
                  <FileDrop frame={document} onDrop={this.props.onImageDropped} targetAlwaysVisible={true}>
                    <div className="file-drop-image-container">
                      <img className="img-fluid" src="/drop-here.png" alt="Drop"/>
                    </div>
                  </FileDrop>
                </ImageInput>
              </div>
              <TitleInput state={this.props.state} onChange={this.props.onTitleChange}/>
            </header>
          </div>
        </section>
      </div>
    );
  }
}

class FullPageHeader extends Component{
  render(){
    return (
      <div className="row App-header App-header-full min-height-full">
        <section className=" col">
          <div className="row">
            <header className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 text-center">
              <div className="image-input-wrapper embed-responsive embed-responsive-16by9">
                <ImageInput imageUploadHandler={this.props.onImageUpload}>
                  <FileDrop frame={document} onDrop={this.props.onImageDropped} targetAlwaysVisible={true}>
                    <div className="file-drop-image-container">
                      <img className="img-fluid" src="/drop-here.png" alt="Drop"/>
                    </div>
                  </FileDrop>
                </ImageInput>
              </div>
              <TitleInput state={this.props.state} onChange={this.props.onTitleChange}/>
            </header>
          </div>
        </section>
        <section className="App-header-footer">
          <p className="full-page-footer"><a href="http://nebula.tv"><img className="standard-star" src="/star-white.png" alt="Nebula logo"/></a></p>
        </section>
      </div>
    );
  }
}

class Footer extends Component{
  render(){
    return(
      <footer className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="offset-lg-2 col-lg-10 offset-xl-3 col-xl-6">
              <p className="full-page-footer"><a href="http://nebula.tv"><img className="standard-star" src="/star-white.png" alt="Nebula logo"/></a></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

class GeneratedThumbnails extends Component{
  render() {
    return(
      <div>
        <div class="darkmode">
          <Toggle onChange={this.props.toggleMode} />
        </div>
        <div className="row">
          <section className=" col">
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
                <h2>Web Browser</h2>
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x home-large">
                <Thumbnail
                  state={this.props.state}
                  title="Home Large"
                  width={360}
                  height={202}
                  titleSize={16}
                  titleWeight={500}
                  titleNumLines={2}
                  titleHeight={4.4}
                  lineHeight={2.2}
                  avatarHeight={36}
                  titleLineLength={265}
                  videoDetails="show"
                  titlePosition="below"
                    />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x home-small">
                <Thumbnail
                  state={this.props.state}
                  title="Home Small"
                  width={240}
                  height={135}
                  titleWeight={500}
                  titleNumLines={2}
                  titleHeight={4}
                  avatarHeight={36}
                  titleLineLength={168}
                  titlePosition="below"
                  videoDetails="show"
                    />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x sidebar">
                <Thumbnail
                  state={this.props.state}
                  title="Sidebar"
                  width={168}
                  height={94}
                  titleWeight={500}
                  titleNumLines={2}
                  titleHeight={4}
                  titleLineLength={202}
                  titlePosition="beside"
                  videoDetails="show"
                  />
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x channel-large">
                <Thumbnail
                  state={this.props.state}
                  title="Channel Page: Large"
                  width={424}
                  height={238}
                  titleWeight={500}
                  titleNumLines={1}
                  titleHeight={2}
                  titleLineLength={400}
                  titlePosition="beside"
                  videoDetails="description"
                    />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x channel-small">
                <Thumbnail
                  state={this.props.state}
                  title="Channel Page: Small"
                  width={210}
                  height={117.5}
                  titleWeight={500}
                  titleNumLines={2}
                  titleHeight={4}
                  titleLineLength={186}
                  titlePosition="below"
                  videoDetails="stats"
                    />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x history">
                <Thumbnail
                  state={this.props.state}
                  title="History"
                  width={246}
                  height={138}
                  titleSize={18}
                  titleNumLines={2}
                  titleHeight={4.8}
                  titleLineLength={300}
                  lineHeight={2.4}
                  titlePosition="beside"
                  videoDetails="combinedDetails"
                    />
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x watch-later-large">
                <Thumbnail
                  state={this.props.state}
                  title="Watch Later: Large"
                  width={312}
                  height={175.5}
                  titlePosition="none"
                    />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x watch-later-list">
                <Thumbnail
                  state={this.props.state}
                  title="Watch Later: List"
                  width={160}
                  height={90}
                  titleSize={16}
                  titleWeight={500}
                  titleLineLength={450}
                  titleHeight={4}
                  titlePosition="beside"
                  videoDetails="channel"
                  />
              </div>
            </div>
          </section>
        </div>


        {/*
          PHONES
        */}

        <div className="row">
          <div className=" col">
            <div className="row">
              <div className="offset-lg-2 col-lg-10 offset-xl-3 col-xl-6">
                <hr/>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <section className=" col">
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
                <h2>Mobile</h2>
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x mobile-home">
                <Thumbnail
                  state={this.props.state}
                  title="Home: Full Width"
                  width={375}
                  height={211}
                  titleSize={14}
                  titleNumLines={2}
                  titleHeight={4}
                  titleLineLength={280}
                  avatarHeight={36}
                  titlePosition="below"
                  videoDetails="combined"
                  detailsSize="12"
                  />
              </div>
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x mobile-column">
                <Thumbnail
                  state={this.props.state}
                  title="Column"
                  width={160}
                  height={90}
                  titleLineLength={150}
                  titlePosition="beside"
                  videoDetails="show"
                  detailsSize="12"
                  titleNumLines={2}
                  titleHeight={4}
                  />
              </div>
            </div>
          </section>
        </div>



        {/*
          APPLE TV
        */}
        <div className="row appletv">
          <section className="col">
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x">
                <h2>Apple TV</h2>
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 scroll-x appletv">
                <Thumbnail
                  state={this.props.state}
                  title="Home"
                  width={512}
                  height={288}
                  titlePosition="below"
                  titleNumLines={2}
                  titleHeight={8}
                  titleLineLength={480}
                  lineHeight={4}
                  titleSize={32}
                  titleWeight={500}
                  videoDetails="show"
                  styles={{
                    'marginBottom':'12px'
                  }}
                  />
              </div>
            </div>
          </section>
        </div>

        <div className="row last">
          <section className=" col">
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
                <h2>Original Image</h2>
              </div>
            </div>
            <div className="row">
              <div className="offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 original">
                <h3>Click to view full size</h3>
                <img className="img-fluid" src={this.props.state.imgSrc} onClick={this.handleScaledImageClick} alt=""/>
                <ViewFullSizedImage imgSrc={this.props.state.imgSrc} show={this.props.state.showFullSize} handleClick={this.handleFullImageClick}/>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}




class WarningBox extends Component{
  handleClick = ()=>{
    this.props.removeWarning(this.props.warningKey);
  }

  render(){
    if(this.props.warnings.length !== 0){
      let warnings = this.props.warnings.map((w, i)=>{
        return (<p key={i}>{w}</p>);
      });
      return (
        <div className="warningContainer">
          <div className="warning">
            <h4>Warning</h4>
            {warnings}
            <button className="btn btn-outline-light btn-xl space-above" onClick={this.handleClick}>Dismiss</button>
          </div>
        </div>
      );
    }else{
      return null;
    }
  }
}
class ImageInput extends Component {
  clickFileInput(){
    document.getElementById("fileInput").click();
  }
  render(){
    if(this.props.children){
      return (
        //IF a child element is provides, wrap it in a div with the hidden element and handle the divs onclick
        <div onClick={this.clickFileInput}>
          {this.props.children}
          <input type="file" id="fileInput" className="form-control-file" onChange={this.props.imageUploadHandler} text="test"/>
        </div>
      )
    }else{
      return (
        //IF no child provided, return a button in a div
        <div className="form-group image-input">
          <button type="button" className="btn btn-primary btn-lg btn-upload-image" onClick={this.clickFileInput}>Browse</button> or drag images here.
          <input type="file" id="fileInput" className="form-control-file" onChange={this.props.imageUploadHandler} text="test"/>
        </div>
      )
    }

  }
}

class TitleInput extends Component{
  selectAll(event){
    event.target.select();
  }
  render(){
    return (
      <input type="text"
        className="form-control"
        onChange={this.props.onChange}
        onFocus={this.selectAll}
        placeholder="Then enter your title to see how it looks together."
        value={this.props.state.title}></input>
    )
  }
}

class ViewFullSizedImage extends Component{
  fullSizedImageClass = ()=>{
    if(this.props.show){
      return "showFullSizeImage"
    }else{
      return "hideFullSizeImage"
    }
  };
  render(){
    return (
      <div className={"full-sized-img "+this.fullSizedImageClass()}
        onClick={this.props.handleClick}>
        <img
          src={this.props.imgSrc}
          alt=""/>
          <div className="full-sized-img-text">CLICK ANYWHERE TO CLOSE</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js